import { GlobalWorkerOptions } from 'pdfjs-dist';

// Ensure worker is loaded before any PDF operations
const workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.mjs',
  import.meta.url
).href;

GlobalWorkerOptions.workerSrc = workerSrc;

// Export for testing
export const getWorkerSrc = () => workerSrc;